<template>
    <el-card>
        <template slot='header'>
        <div>
            <span>发票作废信息</span>
        </div>
        </template>
        <div v-if="type == 'show'">
            作废备注：{{info.cancel_comment}}
        </div>
        <Ly-search-form 
            :config="formConfig" 
            :rules="formRules"
            :is-search="false"
            label-width="120px"
            ref="searchForm"
            v-else>
        </Ly-search-form>
    </el-card>
</template>
<script>
    import LySearchForm from '@c/search-form'
    import LyInformation from '@c/information'
    /**
     * 发票作废信息操作
     * @time 2018-03-19
     * @author zjs
     */
    export default {
        props: {
            infoId: [String, Number], // 发票登记的ID
            info: {
                type: Object,
                default: function () {
                    return {}
                }
            }, // 显示的数据
            type: {
                type: String,
                default: 'show'
            } // 显示类型［show：显示，update: 操作］
        },
        components: {
            LySearchForm,
            LyInformation
        },
        data () {
            return {
                formConfig: [{
                    name: "作废备注",
                    type: "ElInput",
                    field: "cancel_comment",
                    width: '1005px',
                    json: {
                        span: 24
                    },
                    default: ""
                }], // 表单信息配置
                formRules: {
                    'cancel_comment': [{ required: true, trigger: 'blur' }]
                },
                submitForm:{}
            }
        },
        methods: {
            /**
             * 外部调用的数据提交
             */
            submit (callback) {
                if (this.$refs['searchForm'].validateForm()) {
                    // 获得得查询的字段
                    this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                    this.$api.delete('api/invoice/' + this.infoId, this.submitForm).then(() => {
                        callback && callback()
                    }).catch((error) => {
                        this.$message({
                            message: error,
                            type: 'warning'
                        })
                    })
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>